import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=d9f034e8&scoped=true&"
import script from "./officialAccount.vue?vue&type=script&lang=js&"
export * from "./officialAccount.vue?vue&type=script&lang=js&"
import style0 from "./officialAccount.vue?vue&type=style&index=0&id=d9f034e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f034e8",
  null
  
)

export default component.exports